import React from "react";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { styled } from "styled-components";
import { PrimaryButton } from "./shared/Button";
import { scrollToSection } from "./shared/utils";
import { CTAText } from "./shared/CTAText";

const Wrapper = styled.div`
  margin: 0 auto;
  padding: 70px 5%;
  max-width: 1000px;
`;

const Content = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  gap: 50px;
  text-align: left;

  & img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: 50% 40%;
    border-radius: 8px;
  }

  & img,
  div {
    max-width: 768px;
    margin: auto;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    & img {
      height: auto;
    }
  }
`;

const CTA = styled.div`
  width: 300px;
  margin: auto;
  & p {
    text-align: center;
    margin: 30px 0;
  }
  & button {
    display: block;
    margin: 0 auto;
  }
`;

export const DesiredLife = () => {
  return (
    <Wrapper>
      <Subtitle>
        La llave para una vida con libertad, creatividad y futuro
      </Subtitle>
      <Title>
        Imagina un trabajo que te permita vivir donde quieras, trabajar en lo
        que amas y ganar lo que mereces
      </Title>
      <Content>
        <div>
          <p>
            ¿Te gustaría despertarte cada mañana sabiendo que tu trabajo no solo
            te apasiona, sino que te da la libertad de vivir donde quieras, con
            horarios flexibles y un sueldo que te permite alcanzar tus sueños?{" "}
          </p>
          <p>
            Como desarrollador web, no solo tendrás{" "}
            <b>una de las profesiones más demandadas del mundo</b>, sino que
            serás parte de una industria que crece cada día.{" "}
            <b>Podrás trabajar desde casa</b>, para empresas internacionales o
            incluso emprender tu propio negocio.
          </p>
          <p>
            En Beyond te enseñamos las habilidades que necesitas para{" "}
            <b>transforar tu vida</b> y convertirte en un profesional capaz de
            crear soluciones digitales que impacten al mundo.{" "}
          </p>

          <CTA>
            <CTAText>
              Este es el primer paso hacia una vida llena de oportunidades
            </CTAText>
            <PrimaryButton onClick={() => scrollToSection("contact")}>
              Empezar mi nueva vida hoy
            </PrimaryButton>
          </CTA>
        </div>
        <img src="/img/frontend-dev.jpg" />
      </Content>
    </Wrapper>
  );
};
